import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  popupHeader: {
    display: "flex",
    alignItems: "center",
  },
  justifyBetween: {
    justifyContent: "space-between",
  },
  justifyEnd: {
    justifyContent: "end",
  },
  closeIcon: {
    cursor: "pointer",
  },
  titleText: {
    fontWeight: "700",
    fontSize: "18px",
    textAlign: "center",
  },
  quitBtn: {
    borderRadius: "12px",
    borderWidth: "1px",
    padding: "3px 27px",
    border: "1px solid #E76B69",
    fontSize: "16px",
    fontWeight: 500,
    textTransform: "none",
    position: "absolute",
    right: 0,
    marginBottom: "13px",
  },
  okBtnCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    bottom: "9px",
    right: 0,
    left: 0,
  },
  quitDialog: {
    padding: "12px 40px",
    borderRadius: "12px",
    minWidth: "290px",
    minHeight: "180px",
  },
  quitDialogWithBothBtn: {
    padding: "12px 40px",
    borderRadius: "12px",
    minWidth: "350px",
    minHeight: "180px",
    [theme.breakpoints.up("sm")]: {
      minWidth: "402px",
    },
  },
  justifyCenter: {
    justifyContent: "center",
  },
  flex_row: {
    display: "flex",
  },
  quitDialogText: {
    marginTop: "20px",
    marginBottom: "44px",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "15.5px",
    lineHeight: "20px",
    textAlign: "center",
    color: "#5B8989",
  },
  quitDialogBtnContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    position: "absolute",
    bottom: "9px",
    gap: "10px",
    justifySelf: "center",
    left: 0,
    right: 0,
  },
  quitDialogCancelBtn: {
    minWidth: "158px",
    width: "fit-content",
    height: "44px",
    borderRadius: "8px",
    border: "1px solid #E6E6E6",
    textTransform: "none",
    color: "#FF702D0",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "-10px",
      minWidth: "147px",
      width: "fit-content",
    },
  },

  quitDialogConfirmBtn: {
    minWidth: "158px",
    width: "fit-content",
    padding: "0 20px",
    height: "44px",
    borderRadius: "8px",
    color: "#fff",
    backgroundColor: "#FF702D",
    textTransform: "none",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "19.36px",
    "&:hover": {
      backgroundColor: "#FF702D",
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: "-10px",
      minWidth: "147px",
      width: "fit-content",
    },
  },
  deleteIcon: {
    height: "15px",
    width: "15px",
    color: "white",
    marginLeft: "5px",
  },
}));
